import { conceptGallery } from "@/data/site";
import { useI18n } from "@/i18n/I18nProvider";

type Concept = (typeof conceptGallery)[number];

export function ConceptCard({ concept }: { concept: Concept }) {
  const { t } = useI18n();

  return (
    <article className={`concept-card concept-${concept.aspect}`} data-reveal>
      <img src={concept.image} alt={t(concept.titleKey)} loading="lazy" />
      <div className="concept-card-copy">
        <p className="concept-status">{t("common.conceptNotice")}</p>
        <h3>{t(concept.titleKey)}</h3>
        <p>{t(concept.bodyKey)}</p>
      </div>
    </article>
  );
}
